/* eslint-disable import/prefer-default-export */
var UPDATE_LAYOUT = 'UPDATE_LAYOUT';
export { UPDATE_LAYOUT };